import { QueryResources } from 'datx-jsonapi-react';

import { OriginalsMaterial } from '@/resources/OriginalsMaterial';

export const getMaterialsForSeries = (series_id: string): QueryResources<OriginalsMaterial> => {
  return [
    OriginalsMaterial,
    {
      filter: {
        series_id,
      },
      sort: 'position',
      params: [
        {
          key: 'page[size]',
          value: '500',
        },
        {
          key: 'page[number]',
          value: '1',
        },
      ],
    },
  ];
};
